export default "__VITE_ASSET__DNpGsmCk__"